import React from 'react'

function Discover() {
  return (
    <div className="discover">
      <div className="disc-wrap">
          <div className="disc1">
              <h2 className="disc-text1">Metabnb NFTs</h2>
              <p className="disc-text2">Discover our NFT gift cards collection. Loyal customers gets amazing gift cards which are traded as NFTs. These NFTs gives our cutomer access to loads of our exclusive services.</p>
              <button type="button" className="disc-btn">Learn more</button>
          </div>
          <div className="disc2">
              <img src="./img/metabnb-img.png" alt="discovery image" className="disc-img" />
          </div>
      </div>
    </div>
  )
}

export default Discover
